export class Regimenes {

    public intId?:number;
    public strAbreviatura?:string;
    public strNombre?:string;
    public strActivo?:string;

}
